import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userPool, setupTOTP, verifyTOTP, restoreSession, refreshSession } from '../../utils/cognitoUtils';
import { QRCodeCanvas } from 'qrcode.react'; 
import './auth.css';



const SetupAuthenticator = () => {
  const [secretCode, setSecretCode] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const setup = async () => {
      try {
        const cognitoUser = userPool.getCurrentUser();
        console.log("cognitoUser", cognitoUser);

        if (cognitoUser) {
          await restoreSession(cognitoUser);

          // Check if session is valid or needs refresh
          const session = cognitoUser.getSignInUserSession();
          if (session && session.isValid()) {
            console.log('Session is valid');
          } else {
            console.log('Session is not valid, attempting to refresh...');
            await refreshSession(cognitoUser);
          }

          // Fetch the TOTP code
          const code = await setupTOTP(cognitoUser);
          setSecretCode(code);
          console.log("TOTP setup code:", code); // Debugging log
        } else {
          throw new Error('User not found');
        }
      } catch (err) {
        if (err.code === 'NotAuthorizedException') {
          console.log('Access Token has expired or is invalid.');
        } else {
          setError('Failed to setup authenticator. Please try again.');
          console.error("Setup error:", err); // Debugging log
        }
      }
    };
    setup();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const cognitoUser = userPool.getCurrentUser();
      if (cognitoUser) {
        console.log("Verifying TOTP with code:", verificationCode); // Debugging log
        await verifyTOTP(cognitoUser, verificationCode);
        navigate('/signin');
      } else {
        throw new Error('User not found');
      }
    } catch (err) {
      setError('Failed to verify code. Please try again.');
      console.error("Verification error:", err); 
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Setup Authenticator App</h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {secretCode ? (
          <>
            <p>Please follow these steps to set up your authenticator app:</p>
            <ol>
              <li>Open your authenticator app (e.g., Google Authenticator, Authy, Microsoft Authenticator).</li>
              <li>Scan this QR code with your app:</li>
            </ol>
            <div className="qr-code-container">
            <QRCodeCanvas value={`otpauth://totp/CartageManager:${userPool.getCurrentUser().getUsername()}?secret=${secretCode}&issuer=CartageManager`} />
            </div>
            <p>Or manually enter this secret code in your app: {secretCode}</p>
          </>
        ) : (
          <p>Loading secret code...</p> // Add loading indicator
        )}
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter code from authenticator app"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            required
          />
          <button type="submit">Verify and Enable Authenticator</button>
        </form>
      </div>
    </div>
  );
};

export default SetupAuthenticator;